// 配置文件
const config = {
  // API配置
  api: {
    // 基础API地址
    baseURL: process.env.VUE_APP_BASE_API || 'https://group.beijingqianji.com/api/newborntown',
    // 完整API地址
    apiURL: process.env.VUE_APP_API_URL || 'https://group.beijingqianji.com',
    // 请求超时时间
    timeout: 15000
  },
  
  // 环境配置
  env: process.env.NODE_ENV || 'development',
  
  // 是否为开发环境
  isDev: process.env.NODE_ENV === 'development',
  
  // 是否为生产环境
  isProd: process.env.NODE_ENV === 'production',
  
  // 应用配置
  app: {
    title: 'NewbornTown Website',
    version: '1.0.0'
  }
}

export default config